import { call, put, select, takeLatest } from 'redux-saga/effects';

import { mergeIntoUi } from '../actions';
import { APPLICATION_MAP_SERVER_TO_UI } from '../constants/actionTypes';
import { unFlattenObject } from '../lib/builderHelpers';
import { builderSelector } from '../reducers/selectors';

const mappedAttributes = ['passportName'];

function* mapServerToUiWatcher() {
  yield takeLatest(APPLICATION_MAP_SERVER_TO_UI, mapServerToUiWorker);
}

function* mapServerToUiWorker() {
  const builder = yield select(builderSelector);
  const { server, ui } = builder;
  const payload = yield call(unFlattenObject, ui, server, mappedAttributes);
  yield put(mergeIntoUi(payload));
}

export { mapServerToUiWorker, mappedAttributes };
export default mapServerToUiWatcher;
